package one.healthium.profile.navigation.update_age

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultUpdateAgeComponent(
    componentContext: ComponentContext,
    private val onCloseClicked: () -> Unit,
    private val onAgeUpdated: () -> Unit,
) : UpdateAgeComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }

    override fun onAgeUpdated() {
        onAgeUpdated.invoke()
    }
}